import './edu/edu.css';
import logo from './../../assets/img/brand/interrisk.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChild, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';
import Dziecko from './edu/Dziecko';
import { BUY_LINK } from './edu/ProgramTable';

const EDU = () => {
  return (
    <div className="product-selector">
      <div className="header">
        <img style={{ maxWidth: '250px' }} src={logo} alt="InterRisk logo" />
      </div>

      <div className="product-hero">
        <div className="product-hero-icon">
          <FontAwesomeIcon icon={faChild} />
        </div>
        <div className="product-hero-text">
          <span className="product-hero-badge">Program na rok 2026/2027</span>
          <h3>Dziecko</h3>
          <p>
            Ochrona ubezpieczeniowa Twojego dziecka przez 365 dni w roku - w
            szkole, w domu i na wakacjach.
          </p>
        </div>
        <div className="product-hero-cta">
          <ProductCta href={BUY_LINK} icon={faShoppingCart}>
            Kup ubezpieczenie
          </ProductCta>
          <span className="product-hero-cta-hint">
            Wybierz wariant i opłać składkę online
          </span>
        </div>
      </div>

      <Dziecko />

      <ProductCtaBar title="NNW szkolne EDU Plus">
        <ProductCta href={BUY_LINK} icon={faShoppingCart}>
          Kup ubezpieczenie
        </ProductCta>
      </ProductCtaBar>
    </div>
  );
};

export default EDU;
